(ns app.front.view.admin.migration.inspection-template-visit-type
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/update-inspection-template-visit-type
    :title     "Add correct visit type to inspection types"
    :help-text "Visit type will be set to inspection type if none is set."}
   match])

(def route
  {:name        :view/admin.migration.inspection-template-visit-type
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/update-inspection-template-visit-type]))}]})
